import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ScheduledItemId = Brand<number, 'ScheduledItemId'>;
export const ScheduledItemId = createBranded<ScheduledItemId>();
